import access_roles from '@/middleware/pipes/access-roles';
import auth from '@/middleware/pipes/auth';
import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { Orders } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Orders.Pages.ORDERS}`,
    name: Orders.Pages.ORDERS,
    component: () => import(/* webpackChunkName: "orders" */ './views/Orders.vue'),
    meta: {
      access_roles: RouteRoles[Orders.Pages.ORDERS],
    },
  },
  {
    path: `/${Orders.Pages.ORDERS}/${Orders.Pages.ORDER_DETAIL}/:id`,
    name: Orders.Pages.ORDER_DETAIL,
    component: () => import(/* webpackChunkName: "order-detail" */ './views/OrderDetail.vue'),
    meta: {
      access_roles: RouteRoles[Orders.Pages.ORDER_DETAIL],
    },
  },
  {
    path: `/${Orders.Pages.ORDERS}/${Orders.Pages.ORDERS_INVOICES}`,
    name: Orders.Pages.ORDERS_INVOICES,
    component: () => import(/* webpackChunkName: "orders-invoices" */ './views/OrdersInvoices.vue'),
    meta: {
      access_roles: RouteRoles[Orders.Pages.ORDERS_INVOICES],
    },
  },
];

export default routes;
